import { createSelector } from '@ngrx/store';
import {
  FlowTypes,
  JointGiftingApprovalPayload,
  JointGiftingApprovalPosition,
  JointGiftingApprovalTaxLot,
  YesNoEmpty,
} from '@shared/models';
import { getTriageState } from '@store/reducers';
import { CostBasisPosition } from '@store/reducers/cost-basis/cost-basis.reducer';
import { getTaxLotsAmount, getTotalAmountForPosition } from 'sharedUtils/utils.helpers';

import { selectSelectedPositions } from '../cost-basis/cost-basis.selectors';
import { selectGiftingState } from '../gifting/gifting.selectors';
import { selectedAccountsFrom } from '../selected-client-accounts/selected-client-accounts.selectors';

export const getJointGiftingApprovalPayload = createSelector(
  selectGiftingState,
  getTriageState,
  selectedAccountsFrom,
  selectSelectedPositions,
  (
    { recipient },
    { giftingDesignation },
    [account],
    selectedPositions,
  ): JointGiftingApprovalPayload => {
    return {
      gift: {
        accountNumber: recipient.accountNumber,
        anonymous: recipient.anonymousGift === YesNoEmpty.YES,
        dtcNumber: recipient.dtcNumber,
        firm: recipient.firm,
        giftDesignation: giftingDesignation,
        recipientName: recipient.name,
        type: recipient.type,
      },
      sourceAccount: {
        accountId: account?.accountData?.accountId,
        accountNumber: account?.accountNumber,
        positions: getPositionPayload(selectedPositions),
      },
    };
  },
);

const getPositionPayload = (selectedPositions: CostBasisPosition[]) => {
  return selectedPositions.map((position) => {
    const payloadPosition: JointGiftingApprovalPosition = {
      giftingMethod: position.giftingMethod,
      positionId: position.positionId,
      selectedAmount: `${getTotalAmountForPosition(position, FlowTypes.GIFTING)}`,
      costBasisMethod: position.selectedCostBasisMethod,
    };

    if (position.taxLots) {
      payloadPosition.taxLots = position.taxLots
        .filter((taxLot) => {
          const amount = getTaxLotsAmount(position.giftingMethod, taxLot);
          return amount > 0;
        })
        .map((taxLot) => {
          const jointGiftingTaxLot: JointGiftingApprovalTaxLot = {
            lotID: taxLot.lotID,
            selectedAmount: `${getTaxLotsAmount(position.giftingMethod, taxLot)}`,
          };
          return jointGiftingTaxLot;
        });

      if (position.additionalTaxLot) {
        payloadPosition.additionalTaxLotId = position.additionalTaxLot.lotID;
      }
    }
    return payloadPosition;
  });
};
